import actions from './characterActions'
import mutations from './characterMutations'
import getters from './characterGetters'
import state from './characterState'

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
}
